<template>
  <v-simple-table dense>
    <thead>
      <tr>
        <th>Id</th>
        <th>Modalidad</th>
        <th>Carrera</th>
        <th>Asignatura</th>
        <th>Comisión</th>
        <th>Fusion</th>
      </tr>
    </thead>

    <tbody>
      <tr v-if="items.length === 0">
        <td colspan="4">Sin registros</td>
      </tr>

      <tr v-for="com in items" :key="com.Id">
        <td>{{ com.Id }}</td>
        <td>{{ com.Modalidad }}</td>
        <td>{{ com.Carrera }}</td>
        <td>{{ com.Asignatura }}</td>
        <td>{{ com.NombreComision }}</td>
        <td>{{ com.Fusion }}</td>
      </tr>
    </tbody>
  </v-simple-table>
</template>

<script>
export default {
  name: "ComisionesDetalle",
  props: {
    items: {
      type: Array,
      required: true
    }
  }
}
</script>
